import React from "react"

// Overflow boolean checker
function isOverflown(element){
    return element.scrollHeight > element.clientHeight;
}
class GameDescription extends React.Component{
    constructor(){
        super()
        this.state={ 
            expanded: false,
            buttonHidden: false,
            edit: false
        }
        this.lineHeight = 24
        this.minLines = 10
        this.preferredHeight = this.lineHeight*this.minLines
        this.checkEleHeight = this.checkEleHeight.bind(this)
        this.handleResize = this.handleResize.bind(this)
    }
    checkEleHeight(){
        //check if I need to collapse the item
        const text = document.querySelector(".gameDescription p")
        const height = text.offsetHeight;
        //if the element height is smaller than the
        if (height < this.preferredHeight && !isOverflown(text)) this.setState({ expanded: true, buttonHidden: true })
        else this.setState({ buttonHidden: false })
    }
    handleResize(){
        this.checkEleHeight();
    }
    componentDidMount(){
        this.checkEleHeight()
        window.addEventListener("resize", this.handleResize)
    }
    componentWillUnmount(){
        window.removeEventListener("resize", this.handleResize)
    }
    render(){
        const { description } = this.props.data
        const { expanded } = this.state
        const toggleClass = expanded ? "expanded" : "collapsed"
        return(
            <div className="gameDescription section">
                <h2 className="sectionTitle">Game Description</h2>
                {description == null 
                ? <p className="description">
                    "The author hasn't written anything yet."
                </p>
                :<>
                <div className={`description ${toggleClass}`}>
                    <p>{description}</p>
                    <div className="expandBtn" 
                        onClick={() => this.setState(prevState=>{ return{ expanded: !prevState.expanded } })}>
                        {expanded ? 'Read Less' : 'Read More'}
                    </div>
                </div>
                </>}
            </div>
        )
    }
}

export default GameDescription